<script lang="ts">
	import { OutboundLink } from '@cf/ui-lib';

	export let data;
</script>

<div class="flex items-center gap-2.5">
	{#each data as item, index}
		<h3 class="whitespace-nowrap font-inter text-2xl font-bold leading-9 text-dark">
			<span>{item.title}</span>
			{#if data.length - 1 !== index}
				<span>/</span>
			{/if}
		</h3>
	{/each}
</div>
